import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  Badge,
  Btn,
  ConfirmDialog,
  CustomDataTableHeader,
  CustomPanel,
  DateTime,
  PageHeader,
  Periodo,
  SectionTitle,
  ThreeDots,
  InputText,
} from '../../../../components'
import parseTransferStatus from '../../../../constants/delivery-transfer-status'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import ModalTransferencia from './ModalTransferencia/ModalTransferencia'
import useTransferenciaEntrega, { MODAL_TYPES } from './TransferenciaEntregaState'
import { Fieldset } from 'primereact/fieldset'

function TransferenciaEntrega({ selectedTp, history, dispatch }) {
  const { state, localDispatch } = useTransferenciaEntrega()

  useEffect(() => {
    state.modalType === MODAL_TYPES.NONE &&
      localDispatch.onPesquisarTransferencia(selectedTp, state.periodoInicial, state.periodoFinal)
  }, [state.modalType])

  useEffect(() => {
    selectedTp &&
      localDispatch.onPesquisarTransferencia(selectedTp, state.periodoInicial, state.periodoFinal)
  }, [selectedTp])

  useEffect(() => {
    state.errorMessage &&
      dispatch(showMessageBox(null, state.errorMessage)) &&
      localDispatch.resetMessage()
  }, [state.errorMessage])

  useEffect(() => {
    state.navigateToAssociacaoEntregas &&
      history.push('/main/entregas/transferencia-assoc-entrega', {
        transferencia: state.transferenciaSelecionada,
        selectedTp,
      })
  }, [state.navigateToAssociacaoEntregas])

  useEffect(() => {
    switch (state.pathToRedirect) {
      case '/main/entregas/transferencia-assoc-entrega':
        history.push(state.pathToRedirect, {
          transferencia: state.transferenciaSelecionada,
          selectedTp,
        })
        break
      case '/main/entregas/cargas-paradas-transferencia':
        history.push(state.pathToRedirect, {
          transferencia: state.transferenciaSelecionada,
          selectedTp,
        })
        break
      default:
        break
    }
  }, [state.pathToRedirect])

  useEffect(() => {
    if (state.isLoading && selectedTp) dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
    else dispatch(hideLoadingBox())
  }, [state.isLoading, selectedTp])

  return (
    <div>
      <PageHeader>3.2 - Transferência de Entrega entre Trechos</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => localDispatch.novaTransferencia(selectedTp)}
          onVoltar={history.goBack}
        >
          <div className="p-col-12">
            <Btn onClick={localDispatch.navigateToCargasParadas}>Listagem Cargas Paradas</Btn>
          </div>
          <div className="p-col-12">
            <SectionTitle title="Histórico de Transferências" />
          </div>
          <div className="p-col-12" style={{ display: 'flex' }}>
            <Periodo
              periodoInicial={state.periodoInicial}
              periodoFinal={state.periodoFinal}
              onPesquisar={(pInicial, pFinal) => {
                localDispatch.onPesquisarTransferencia(selectedTp, pInicial, pFinal)
              }}
            />
            <div style={{ marginLeft: 10, paddingTop: 27 }}>
              <Btn onClick={() => localDispatch.onBtnExportarClick(state.transferenciasSelecionadas)}>
                Exportar
              </Btn>
            </div>
          </div>
          <div className="p-col-12" style={{ marginTop: 16 }}>
            <Fieldset legend="Filtro" toggleable collapsed={true} className="p-col-12">
              <div className="p-grid p-align-center">
                <div className="p-col-6">
                  <InputText
                    label="Nota Fiscal"
                    value={state.notaFiscal}
                    onChange={value => localDispatch.setNotaFiscal(value)}
                  />
                </div>
                <div className="p-col-2" style={{ marginTop: 32 }}>
                  <Btn onClick={localDispatch.filtrarPorNota}>Buscar</Btn>
                </div>
              </div>
            </Fieldset>
          </div>
          <div className="p-col-12" style={{ marginTop: 16 }}>
            <DataTable
              value={state.transferencias}
              emptyMessage="Não existe nenhuma Transferência cadastrada"
              globalFilter={state.globalFilter}
              header={
                <CustomDataTableHeader
                  onChange={value => localDispatch.setGlobalFilter(value)}
                  value={state.globalFilter}
                />
              }
              rows={15}
              paginator
              dataKey="transfer_id"
              selection={state.transferenciasSelecionadas}
              onSelectionChange={e => localDispatch.setTransferenciasSelecionadas(e.value)}
            >
              <Column selectionMode="multiple" style={{ width: '3em' }} />
              <Column field="transfer_id" header="Código" style={tableCellCentered(80)} />
              <Column
                field="created_at"
                header="Criada Em"
                style={tableCellCentered(100)}
                body={value => <DateTime>{value.created_at}</DateTime>}
              />
              <Column field="transfer_name" header="Transferência" />
              <Column field="qte_deliveries" header="Qte. Entregas" style={tableCellCentered(80)} />
              <Column field="destinations" header="Destino" />
              <Column
                field="departure_date"
                header="Data da Partida"
                body={transferencia => <DateTime>{transferencia.departure_date}</DateTime>}
                style={tableCellCentered()}
              />
              <Column
                field="departure_time"
                header="Horário da Partida"
                style={tableCellCentered()}
              />
              <Column field="vehicle_plate" header="Placa" style={tableCellCentered()} />
              <Column
                field="status"
                header="Status"
                style={tableCellCentered(170)}
                body={transferencia => {
                  const status = parseTransferStatus(transferencia.status)
                  return <Badge color={status.color}>{status.label}</Badge>
                }}
                bodyStyle={tableCellCentered()}
              />
              <Column field="identifiers" header="identifiers" style={{ display: 'none' }} />
              <Column
                header="Menu"
                style={tableCellCentered(70)}
                body={transferencia => (
                  <ThreeDots
                    items={[
                      'Editar',
                      'Assoc. Entregas',
                      'Mapa de Carregamento - Estoque',
                      'Transferir',
                      'Cancelar Transferência',
                    ]}
                    onClick={item => localDispatch.onItemClick(item, transferencia, selectedTp)}
                  />
                )}
                bodyStyle={tableCellCentered()}
              />
            </DataTable>
          </div>
        </CustomPanel>
      </div>
      {
        // InputMask só funciona se for carregado como uma NOVA INSTANCIA - PrimeReact Bug
        state.modalType === MODAL_TYPES.FORMULARIO && (
          <ModalTransferencia
            onResponse={localDispatch.modalFormularioResponseHandler}
            selectedTp={selectedTp}
            transferencia={state.transferenciaSelecionada}
          />
        )
      }
      <ConfirmDialog
        isVisible={state.modalType === MODAL_TYPES.CONFIRMACAO_TRANSFERENCIA}
        title="Atenção"
        content={<span>Confirma a Transferência ?</span>}
        onCancelar={localDispatch.closeModal}
        onOk={() => localDispatch.changeStatus(state.transferenciaSelecionada, 'Transferir')}
      />
      <ConfirmDialog
        isVisible={state.modalType === MODAL_TYPES.CONFIRMACAO_CANCELAMENTO}
        title="Atenção"
        content={
          <span>
            Confirma o <strong>CANCELAMENTO</strong> desta Transferência ?
          </span>
        }
        onCancelar={localDispatch.closeModal}
        onOk={() => localDispatch.changeStatus(state.transferenciaSelecionada, 'Cancelar')}
      />
    </div>
  )
}
const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(TransferenciaEntrega))
